import React, { useState, useEffect, useRef } from "react";
import { BASE_URL } from "../../../constants";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import { Row, Col, Container, Card, InputGroup } from "react-bootstrap";
import "../../../CommonCSS/SocietyCSS.css";

const Bulk_Leave_Cert = () => {

  const [formData, setFormData] = useState({
    record_id: "",
    studying_since: "",
    leave_reason: "",
    progress: "",
    conduct: "",
    lc_date: "",
    year: "",
    remarks: "",
    student_name: "",
  });

  const [isEditable, setIsEditable] = useState(false);
  const [savedData, setSavedData] = useState([]);
  const inputRef = useRef(null);

  useEffect(() => {
    fetchSavedData();
  }, []);

  const fetchSavedData = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/api/get_student_progress`);
      setSavedData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleNew = () => {
    setIsEditable(true);
  };

  const handleClear = () => {
    if (!window.confirm("Sure you want to clear?")) return;
    setIsEditable(false);
    setFormData({
      record_id: "",
      studying_since: "",
      leave_reason: "",
      progress: "",
      conduct: "",
      lc_date: "",
      year: "",
      remarks: "",
      student_name: "",
    });
  };

  const handleSave = async () => {
    if (!formData.studying_since || !formData.progress) {
      alert("Required fields missing");
      return;
    }

    if (!window.confirm("Do you want to save this record?")) return;

    try {
      const response = await axios.post(
        `${BASE_URL}/api/save_student_progress`,
        formData
      );

      if (response.data.message === "1") {
        alert("Record saved successfully!");
        fetchSavedData();
        setIsEditable(false);
        handleClear();
      } else {
        alert("Failed to save record");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleRowClick = (row) => {
    setFormData(row);
    setIsEditable(true);
  };

  return (
    <Container fluid className="p-3">

      {/* ================= FORM CARD ================= */}
      <Card className="mb-4">
        <Card.Body>

          <Row className="mb-3">
            <Col md={3}>
              <InputGroup>
                <InputGroup.Text style={{ width: "150px" }}>
                  LC Date<span style={{ color: "red" }}>*</span>
                </InputGroup.Text>
                <input
                  type="date"
                  name="lc_date"
                  className="form-control"
                  value={formData.lc_date}
                  onChange={handleChange}
                  disabled={!isEditable}
                />
              </InputGroup>
            </Col>

            <Col md={3}>
              <InputGroup>
                <InputGroup.Text style={{ width: "150px" }}>LC No</InputGroup.Text>
                <input className="form-control" disabled />
              </InputGroup>
            </Col>

            <Col md={3}>
              <InputGroup>
                <InputGroup.Text style={{ width: "150px" }}>Status</InputGroup.Text>
                <select className="form-select" disabled>
                  <option>New</option>
                  <option>Approved</option>
                </select>
              </InputGroup>
            </Col>

            <Col md={3}>
              <InputGroup>
                <InputGroup.Text style={{ width: "150px" }}>Year</InputGroup.Text>
                <input className="form-control" disabled />
              </InputGroup>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={6}>
              <InputGroup>
                <InputGroup.Text style={{ width: "150px" }}>
                  Studying Since<span style={{ color: "red" }}>*</span>
                </InputGroup.Text>
                <input
                  name="studying_since"
                  className="form-control"
                  value={formData.studying_since}
                  onChange={handleChange}
                  disabled={!isEditable}
                />
              </InputGroup>
            </Col>

            <Col md={6}>
              <InputGroup>
                <InputGroup.Text style={{ width: "150px" }}>
                  Leave Reason<span style={{ color: "red" }}>*</span>
                </InputGroup.Text>
                <input
                  name="leave_reason"
                  className="form-control"
                  value={formData.leave_reason}
                  onChange={handleChange}
                  disabled={!isEditable}
                />
              </InputGroup>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={6}>
              <InputGroup>
                <InputGroup.Text style={{ width: "150px" }}>Conduct</InputGroup.Text>
                <input
                  name="conduct"
                  className="form-control"
                  value={formData.conduct}
                  onChange={handleChange}
                  disabled={!isEditable}
                />
              </InputGroup>
            </Col>

            <Col md={6}>
              <InputGroup>
                <InputGroup.Text style={{ width: "150px" }}>Progress</InputGroup.Text>
                <input
                  name="progress"
                  className="form-control"
                  value={formData.progress}
                  onChange={handleChange}
                  disabled={!isEditable}
                />
              </InputGroup>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={6}>
              <InputGroup>
                <InputGroup.Text style={{ width: "150px" }}>Remarks</InputGroup.Text>
                <textarea
                  name="remarks"
                  className="form-control"
                  rows="1"
                  value={formData.remarks}
                  onChange={handleChange}
                  disabled={!isEditable}
                />
              </InputGroup>
            </Col>
          </Row>

          {/* ================= ACTION BUTTONS ================= */}
           <div className="d-flex justify-content-end gap-2 mt-3 flex-wrap">

            <button
              type="button"
              className="btn btn-primary"
              style={{ width: "135px" }}
              onClick={handleNew}
              disabled={isEditable}
            >New
            </button>

            <button
              type="button"
              className="btn btn-warning"
              style={{ width: "135px" }}
              // onClick={handleEdit}
              disabled={!formData.gr_no || isEditable}
            >Edit
            </button>

            <button
              type="button"
              className="btn btn-info"
              style={{ width: "135px" }}
              // onClick={handlePreview}
              disabled={!formData.gr_no}
            > Preview LC
            </button>

            <button
              type="button"
              className="btn btn-dark"
              style={{ width: "135px" }}
              // onClick={handlePrint}
              disabled={!formData.gr_no}
            > Print LC
            </button>

            <button
              type="button"
              className="btn btn-secondary"
              style={{ width: "135px" }}
              onClick={handleClear}
            > Clear
            </button>

            <button
              type="button"
              className="btn btn-success"
              style={{ width: "135px" }}
              onClick={handleSave}
              disabled={!isEditable}
            > Save
            </button>
          </div>

        </Card.Body>
      </Card>

      {/* ================= TABLE CARD ================= */}
      <Card className="p-3">
        <h5 className="mb-4">Student Progress / Leave Certificate Records</h5>

        <div className="table-wrapper">
          <table className="responsive-table scty-custom-table">
            <thead>
              <tr>
                <th style={{ width: "5%" }}>#</th>
                <th style={{ width: "10%" }}>GR No</th>
                <th style={{ width: "50%" }}>Student Name</th>
                <th style={{ width: "20%" }}>Leave Reason</th>
                <th style={{ width: "15%", textAlign: "center" }}>Select</th>
              </tr>
            </thead>

            <tbody>
              {savedData.length > 0 ? savedData.map((item, index) => (
                <tr key={item.record_id} onClick={() => handleRowClick(item)}>
                  <td>{index + 1}</td>
                  <td>{item.student_name}</td>

                  {/* 🔽 DROPDOWN COLUMN */}
                  <td onClick={(e) => e.stopPropagation()}>
                    <select className="form-select form-select-sm">
                      <option value="">Select Reason</option>
                      <option value="TRANSFER">Transfer</option>
                      <option value="COMPLETED">Completed Studies</option>
                      <option value="PARENT_REQUEST">Parent Request</option>
                      <option value="OTHER">Other</option>
                    </select>
                  </td>

                  <td style={{ textAlign: "center" }}>
                    <input
                      type="checkbox"
                      onClick={(e) => e.stopPropagation()}
                    />
                  </td>
                </tr>
              )) : (
                <tr>
                  <td colSpan="5" className="text-center">No records found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </Card>

    </Container>
  );
};

export default Bulk_Leave_Cert;
  